'use strict';

module.exports = ['USD', 'GBP', 'EUR', 'CAD', 'AUD', 'CHF', 'MXN'];



//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-currency-helpers/currencies.js
// module id = ./node_modules/dibs-currency-helpers/currencies.js
// module chunks = 4